import { OfficeTourPage } from "~/components/office-tour/OfficeTourPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/office-tour")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/office-tour"),
  component: OfficeTourPage,
});
